import { Grid } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { restApi } from '../../services/api';

const useStyles = makeStyles()(() => ({
  medias: {
    aspectRatio: 1,
    width: '100%',
    objectFit: 'cover',
  },
}));

const INSTAGRAM_FIELDS = ['media_count', 'media_type', 'permalink', 'media_url', 'caption'];

type InstagramPost = {
  caption: string;
  media_type: 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM';
  id: string;
  media_url: string;
  permalink: string;
};

type InstagramResponse = {
  data: InstagramPost[];
};

type InstagramFeedProps = {
  instagramToken: string;
};

const InstagramFeed = ({ instagramToken }: InstagramFeedProps) => {
  const [posts, setPosts] = useState<InstagramPost[] | undefined>();
  const { classes } = useStyles();

  const loadPosts = useCallback(async () => {
    const postResults = await restApi.get<InstagramResponse>(
      'https://graph.instagram.com/me/media',
      {
        fields: INSTAGRAM_FIELDS.join(','),
        access_token: instagramToken,
      },
    );
    if (postResults.ok) {
      setPosts(postResults?.data?.data);
    }
  }, [instagramToken]);

  useEffect(() => {
    loadPosts();
  }, [loadPosts]);

  return (
    <Grid container spacing={4}>
      {posts?.slice(0, 8).map((post, index) => (
        <Grid
          key={`post-${index}`}
          size={{
            xs: 12,
            sm: 6,
            md: 3,
          }}
        >
          <a href={post.permalink} target="_blank" rel="noreferrer">
            {['IMAGE', 'CAROUSEL_ALBUM'].includes(post.media_type) ? (
              <img
                src={post.media_url}
                key={post.id}
                alt={post.caption}
                className={classes.medias}
              />
            ) : (
              <video src={post.media_url} key={post.id} className={classes.medias}>
                <track kind="captions" />
              </video>
            )}
          </a>
        </Grid>
      ))}
    </Grid>
  );
};

export default InstagramFeed;
